import React from "react";
import './ProgramsButton.scss'
import { Link } from "react-router-dom";

function ShowCreateProgram() {
    return(
        <Link className="link--to--country" to="/admin-users/programs">
            <button className="btn-paises ms-4">Programas</button>
        </Link>
    );
}

export default ShowCreateProgram;